import { useResourceRecordContext } from '@/shared/hooks'

import { AccountDeletion } from '../AccountDeletion'

/**
 * Seção de privacidade — hoje só exclusão de conta.
 *
 * A ação destrutiva ganha seção própria de propósito: antes ela ficava no fim
 * do mesmo scroll de quem só queria trocar o nome.
 */
export const PrivacyPanel = () => {
  const { record: user } = useResourceRecordContext()

  return <AccountDeletion user={user} />
}
